import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from '@inoventoryapps/keycloak-angular';
import { LocalService } from '../services/storage/storage.service';

@Injectable({
    providedIn: 'root'
})
export class AuthKeycloakGuard extends KeycloakAuthGuard {
    constructor(
    protected _router: Router,
    protected _keycloakAngular: KeycloakService,
    private localService: LocalService
    ) {
        super(_router, _keycloakAngular);
    }

    async isAccessAllowed(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Promise<boolean | UrlTree> {

        if (!this.authenticated) {
            await this._keycloakAngular.login({
                redirectUri: window.location.origin + state.url,
            });
        }

        return this.authenticated;
    }

}
